<!-- eslint-disable max-len -->
<template>
  <v-col cols="12">
    <div class="headerInventory">
      <v-btn
        color="secondary"
        @click="toggleExpandCollapse"
      >
        {{ collapseExpandAll !== 'collapseAll' ? $t('tree.collapseAll') : $t('tree.expandAll') }}
      </v-btn>
      <div>
        <v-btn
          icon
          data-cy="cy-grid-view"
          @click="view = 'product'"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 101 102"
            :fill="view === 'product' ? colorRed : colorBlue"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1566 101.521C12.3865 101.521 10.0159 100.535 8.04496 98.5641C6.07398 96.5932 5.08681 94.2209 5.08345 91.4474V34.66C3.57248 33.7367 2.35531 32.5413 1.43193 31.074C0.508562 29.6067 0.046875 27.906 0.046875 25.9719V10.8622C0.046875 8.0921 1.03404 5.72155 3.00838 3.75057C4.98272 1.77959 7.35327 0.79242 10.12 0.789062H90.7053C93.4754 0.789062 95.8476 1.77623 97.822 3.75057C99.7963 5.72491 100.782 8.09546 100.778 10.8622V25.9719C100.778 27.9026 100.317 29.6033 99.3934 31.074C98.47 32.5447 97.2528 33.7383 95.7418 34.655V91.4474C95.7418 94.2176 94.7564 96.5898 92.7854 98.5641C90.8144 100.538 88.4422 101.524 85.6687 101.521H15.1566ZM15.1566 36.0451V91.4474H85.6687V36.0451H15.1566ZM10.12 25.9719H90.7053V10.8622H10.12V25.9719ZM35.3029 61.228H65.5224V51.1548H35.3029V61.228Z"
            />
          </svg>
        </v-btn>

        <v-btn
          icon
          data-cy="cy-grid-view"
          @click="view = 'location'"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 117 117"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <path
              d="M58.6698 10.8906C40.6075 10.8906 25.9531 24.8384 25.9531 42.0169C25.9531 61.7832 47.7642 93.1072 55.773 103.926C56.1055 104.383 56.5412 104.755 57.0446 105.011C57.548 105.267 58.1049 105.401 58.6698 105.401C59.2347 105.401 59.7916 105.267 60.295 105.011C60.7984 104.755 61.2342 104.383 61.5666 103.926C69.5754 93.1117 91.3865 61.7991 91.3865 42.0169C91.3865 24.8384 76.7321 10.8906 58.6698 10.8906Z"
              :stroke="view === 'location' ? colorRed : '#26384B'"
              stroke-width="9.30608"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M58.6712 54.5142C64.6942 54.5142 69.5767 49.6317 69.5767 43.6087C69.5767 37.5857 64.6942 32.7031 58.6712 32.7031C52.6482 32.7031 47.7656 37.5857 47.7656 43.6087C47.7656 49.6317 52.6482 54.5142 58.6712 54.5142Z"
              :stroke="view === 'location' ? colorRed : '#26384B'"
              stroke-width="9.30608"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </v-btn>
      </div>
    </div>
    <div>
      <VBoxWithTitle
        v-for="(itm, productKey) in productInventory"
        :key="itm.id"
        :collapseExpandAll="collapseExpandAll"
        openingIcon="mdi-chevron-down"
        collapsible
        containerClass="networkBox"
        closingIcon="mdi-chevron-up"
        style="margin-bottom: 8px;"
      >
        <template #header>
          <v-toolbar-title>
            {{ productKey }}
          </v-toolbar-title>
        </template>
        <template #content>
          <VTableRemote
            :key="refreshKey"
            :isSearchable="false"
            :showHeader="false"
            :items="itm"
            :headers="tableHeadersProduct"
            :centerColumns="['quantity', 'numberOfUnits', 'unit']"
            :pagination="{}"
            hideDefaultFooter
            sortBy="treeOrder"
            class="dataTableInventoryWO"
          >
            <template v-slot:item.product="{item}">
              <div>
                {{ item.product.name }}
              </div>
            </template>
            <template v-slot:item.expirationDate="{item}">
              <div>
                <VDatePicker
                  v-model="item.expiration"
                  outlined
                  flat
                  class="quantityProduct-InventoryWO-fields"
                  :disabled="isCompletedOrLocked"
                  @change="onClickUpdate(item, 'expiration')"
                />
              </div>
            </template>

            <template v-slot:item.quantity="{item}">
              <div
                :key="refreshKey"
                style="display: flex; align-items: center; align-content: center; flex-direction: column;"
                class="quantityProduct-InventoryWO-fields"
              >
                <VTextField
                  v-model="item.quantity"
                  min="0"
                  type="text"
                  extraClass="quantityProduct-InventoryWO-qty"
                  :rules="{ min: 0, max: 500 }"
                  persistentHint
                  hideDetails
                  style="width: 165px"
                  :disabled="isCompletedOrLocked"
                  @change="onQuantityChange(item)"
                />
                <span
                  class="quantityProduct-InventoryWO-blocNorm"
                  :style="$utils.isBetween(Number(item.quantity), Number(item.quantityMin), Number(item.locationCapacity)) ? 'background-color: #2A750F' : 'background-color: #AD1C3F'"
                >
                  {{ item.quantityMin }} - {{ item.locationCapacity }}
                </span>
              </div>
            </template>
            <template v-slot:item.numberOfUnits="{item}">
              <div style="text-align: center !important;">
                {{ item.totalQuantity }}
              </div>
            </template>
          </VTableRemote>
        </template>
      </VBoxWithTitle>
    </div>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import VBoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import VTableRemote from '@/components/shared/content-views/VTableRemote.vue';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import moment from 'moment';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { debounce } from 'lodash';
import completionStatus from '@/constants/workOrderStatusChoices';

export default {
    components: {
        VBoxWithTitle,
        VTableRemote,
        VDatePicker,
        VTextField,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        expirationDataCy: {
            type: String,
            default: '',
        },
        quantityDataCy: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            refreshKey: 0,
            view: 'location',
            productInventory: [],
            collapseExpandAll: 'collapseAll',
            debounceUpdateQuantity: debounce(this.updateQuantity, 500), // Placeholder for the debounced function
        };
    },

    computed: {
        ...mapGetters([
            'workOrder',
            'lang',
        ]),

        tableHeadersProduct() {
            return [
                this.view === 'product' ? 'location' : 'product',
                'expirationDate',
                'container',
                'quantity',
                'numberOfUnits',
                'unit',
            ].map(header => ({
                text: this.$t(`inventory.labels.${header}`),
                value: header,
                sortable: false,
                // class: this.getClassName(header),
            }));
        },

        location() {
            return Location;
        },
        colorRed() {
            return this.$vuetify.theme.themes.light.error;
        },
        colorBlue() {
            return this.$vuetify.theme.themes.light.primary;
        },
        isCompletedOrLocked() {
            return this.workOrder?.completionStatus === completionStatus.COMPLETED || !!this.workOrder?.lockData?.isLocked;
        },

    },
    watch: {
        view: {
            handler() {
                this.refreshKey += 1;
                this.getProductInventory();
            },
        },
    },
    async created() {
        this.getProductInventory();
    },

    methods: {
        async getProductInventory() {
            const { data } = await this.$rq.getInventoryActivity(this.workOrder.id, this.view);
            const transformItems = Object.fromEntries(
                Object.entries(data.items).map(([key, items]) => [
                    key,
                    items.map(item => ({
                        ...item,
                        quantity: !item.quantity || Number(item.quantity) === 0 ? '' : item.quantity,
                        totalQuantity: !item.totalQuantity || Number(item.totalQuantity) === 0 ? '' : item.totalQuantity,
                    })),
                ]),
            );
            this.productInventory = transformItems;
            this.refreshKey += 1;
        },
        debounceQuantity: debounce(item => {
            this.onClickUpdate(item, 'quantity');
        }, 500),
        async onClickUpdate(item, attribute) {
            const bodyParam = {
                id: item.productInventory,
                [attribute]: attribute === 'expiration' ? moment(item[attribute]).format() : item[attribute],
            };

            try {
                const response = await this.$rq.updateInventoryActivityItem(this.workOrder.id, [bodyParam]);
                if (response.status === 200) {
                    this.refreshKey += 1;
                    this.getProductInventory();
                }
            } catch (error) {
                console.error('Failed to update inventory item:', error);
            }
        },
        async updateQuantity(item) {
            const bodyParam = {
                id: item.productInventory,
                quantity: item.quantity || 0,
            };

            const response = await this.$rq.updateInventoryActivityItem(
                this.workOrder.id,
                [bodyParam],
            );
            if (response.status === 200) {
                this.refreshKey += 1;
                this.getProductInventory();
            }
        },
        onQuantityChange(item) {
            this.debounceUpdateQuantity(item);
        },
        toggleExpandCollapse() {
            if (this.collapseExpandAll === 'collapseAll') {
                this.collapseExpandAll = 'expandAll';
            } else {
                this.collapseExpandAll = 'collapseAll';
            }
            this.refreshKey += 1;
        },

    },

};
</script>
<style
  lang="scss"
>
  .headerInventory {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin-bottom: 20px;
  }
  .dataTableInventoryWO .v-data-table__wrapper {
    height: auto !important;
    width: 100%;
  }
  .quantityProduct-InventoryWO-fields .v-text-field__details{
    display: none;
  }

  .quantityProduct-InventoryWO-blocNorm {
    height: 22px ;
    width: 165px;
    border-radius: 5px;
    margin-top: 8px;

    // Text inside
    color: white;
    text-align: center;
    vertical-align: middle;
  }
  .quantityProduct-InventoryWO-qty {
    margin: 0px ;
    padding: 0px ;
    input  {
      text-align: center !important;
    }
  }

</style>
